var _path, _path2, _path3, _circle, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h500v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M42 42h416v216H42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h416L42 258h416z",
    fill: "#fcd116"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 36,
    cy: 150,
    cx: 250,
    fill: "#ce1126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.749 150.41c4.504 8.39 13.265 17.52 20.916 20.73.123-8.52-2.9-19.44-7.034-28.14z",
    fill: "#ce1126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.112 121.63c6.529 13.61-16.933 46.08 22.156 53.69-4.822-6.58-7.931-17.44-6.755-26.16 8.201 3.12 16.83 12.25 20.317 19.23 10.23-37.15-26.24-34.89-35.718-46.76zM150 259.5l-11.462 35.276 30.008-21.802h-37.091l30.007 21.802zm100 0l-11.462 35.276 30.007-21.802h-37.09l30.007 21.802zm100 0l-11.462 35.276 30.008-21.802h-37.091l30.007 21.802zm0-258l-11.462 35.276 30.007-21.802h-37.09l30.007 21.802zm-100 0l-11.462 35.276 30.007-21.802h-37.09l30.007 21.802zm-100 0l-11.462 35.276 30.007-21.802h-37.09l30.007 21.802zM250 117l-19.397 59.697 50.782-36.895h-62.77l50.782 36.895z",
    fill: "#fcd116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.33a919decbba1420cb97eea44be17046.svg";
export { ForwardRef as ReactComponent };